import { type IPromotionPage } from '@entities/promotion';
import { CardWrapper } from '@shared/ui/content-containers';
import { ExternalImage } from '@shared/ui/image';

interface IPromoContent {
  mainDomain: string;
  item: IPromotionPage;
  image: string;
  categoryName?: string;
}

export function PromoCardDesktop({
  item,
  mainDomain,
  image,
  categoryName,
}: IPromoContent) {
  const { stockpage_title, description_stock } = item;

  return (
    <CardWrapper className="relative h-full">
      <div className="group grid h-full grid-rows-[auto_1fr] overflow-hidden">
        <ExternalImage
          src={image}
          mainDomain={mainDomain}
          alt={stockpage_title}
          width={740}
          height={490}
          sizes={{
            mobile: {
              width: 400,
              height: 300,
            },
            tablet: {
              width: 350,
              height: 250,
            },
            desktop: {
              width: 750,
              height: 500,
            },
          }}
        />
        {categoryName && (
          <div className="absolute top-1 left-2.5 bg-(--common-1) px-1 text-base text-white">
            {categoryName}
          </div>
        )}
        {(stockpage_title || description_stock) && (
          <div className="relative mt-auto min-h-22">
            <div
              className="transition-translate absolute top-0 left-0 flex w-full flex-col gap-2 bg-white
                p-2.5 duration-200 ease-in group-hover:-translate-y-10"
            >
              <span className="text-base font-medium text-(--black)">
                {stockpage_title}
              </span>
              <span
                className="line-clamp-2 overflow-hidden text-sm text-ellipsis text-gray
                  group-hover:line-clamp-4"
              >
                {description_stock}
              </span>
            </div>
          </div>
        )}
      </div>
    </CardWrapper>
  );
}
